import { Injector, ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SelectHelpperComponent } from './select-helpper.component';
import { NbCardModule } from '@nebular/theme';

import { OptionTemplateDirective, SelectedItemTemplateDirective } from './select-helpper.directive';

@NgModule({
  imports: [
    CommonModule, 
    NbCardModule,
    FormsModule,
  ],
  declarations: [
    SelectHelpperComponent,
    OptionTemplateDirective,
    SelectedItemTemplateDirective
  ],
  exports: [
    SelectHelpperComponent,
    OptionTemplateDirective,
    SelectedItemTemplateDirective
  ],
})
export class SelectHelpperModule {}


// WEBPACK FOOTER //
// ./src/app/components/select-helpper/select-helpper.module.ts